const standardHeaders: HeadersInit = {
  "Content-Type": "application/json; charset=utf-8",
};
export const createFetch = async (
  url: string,
  init: RequestInit
): Promise<Response> => {
  try {
    const fetchReq = await fetch(url, {
      ...init,
      credentials: "include",
      mode: "cors",
      headers: standardHeaders,
    });
    return fetchReq;
  } catch (error) {
    throw new Error((error as any).message);
  }
};

export const createGet = (url: string) => createFetch(url, { method: "GET" });

export const createPost =
  () =>
  <TBody extends {}>(url: string, body: TBody) =>
    createFetch(url, { method: "POST", body: JSON.stringify(body) });
